import { EVENT_MANAGER_PLUGINS, EventManagerPlugin } from '@angular/platform-browser';

export class EventPreventStopPlugin extends EventManagerPlugin {
  addEventListener(
    element: HTMLElement,
    eventName: string,
    handler: (event: Event) => void
  ): () => void {
    const shouldStopPropagation = eventName.includes('.stop');
    const shouldPreventDefault = eventName.includes('.prevent');
    // Remove the .prevent modifier to get the base event name
    const baseEventName = eventName.replace('.prevent', '').replace('.stop', '');

    // Create a wrapper function that calls preventDefault
    const wrappedHandler = (event: Event) => {
      if (shouldPreventDefault) {
        event.preventDefault();
      }

      if (shouldStopPropagation) {
        event.stopPropagation();
      }

      handler(event);
    };

    // Add the event listener with the base event name
    element.addEventListener(baseEventName, wrappedHandler);

    // Return a function to remove the event listener
    return () => {
      element.removeEventListener(baseEventName, wrappedHandler);
    };
  }

  supports(eventName: string): boolean {
    return eventName.includes('.prevent') || eventName.includes('.stop');
  }
}

/**
 * Provider function to register the ClickPreventPlugin with EVENT_MANAGER_PLUGINS
 */
export function provideEventPreventStopPlugin() {
  return {
    multi: true,
    provide: EVENT_MANAGER_PLUGINS,
    useClass: EventPreventStopPlugin,
  };
}
